<div>
  <div class="q-heading">
    <ng-content select="[title]"></ng-content>
  </div>
</div>
